export const allowedBlockTypes = ["paragraph"];

/** @type {import('../types').htmlToBlock} */
export const htmlToBlock = ({ element }) => {
  if (element.tagName === "div" || element.tagName === "p") {
    return { type: "paragraph" };
  }
  return null;
};
